import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import SweetAlert from "sweetalert2";
import { Link } from "react-router-dom";
import NoDataHandler from "../../components/common/NoDataHandler";
import LoadingComponent from "../../components/common/LoadingComponent";
import { SITE_URL } from "../../services/Const";

const StockReport = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setLoading(true);
        setData([]);

        axiosConfig.get("stock-report", setHeader())
            .then((res) => {
                setData(res.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const filteredData = data.filter((item) =>
        item.productName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) {
        return (
            <LoadingComponent breadCrubTitle='Home Section List' breadCrubParent='Home Section' />
        );
    }

    if (!loading && filteredData.length === 0) {
        return (
            <Fragment>
                <Breadcrumb title="Stock Report" parent="Reports" />
                <div className="container my-4">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by product name..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <NoDataHandler title='No Stock Report Data' />
                </div>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Breadcrumb title="Stock Report" parent="Reports" />
            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by product name..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <thead className="">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Product Name</th>
                                        <th scope="col">Total Inward</th>
                                        <th scope="col">Total Outward</th>
                                        <th scope="col">Available Stock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>
                                                    <img
                                                        width={50}
                                                        src={
                                                            item.images && JSON.parse(item.images)?.[0]
                                                                ? `${SITE_URL}/images/product/${JSON.parse(item.images)[0]}`
                                                                : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYdegKu0S8BLADKA0D34IuLphlPgUQ3dRXkw&s'
                                                        }
                                                        alt=""
                                                    />
                                                </td>
                                                <td>{item.productName}</td>
                                                <td>{item.total_inward}</td>
                                                <td>{item.total_outward}</td>
                                                <td>{item.stock_count}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default StockReport;
